import { mapGetters } from 'vuex';
export default {
  name: 'TasksProgress',
  computed: {
    ...mapGetters('tasks', ['tasksCount', 'tasksDone']),
    percent() {
      return this.tasksDone / this.tasksCount * 100;
    },
    style() {
      return `width: ${this.percent}%`;
    },
    color() {
      // if (this.percent < 100) {
      //     return 'bg-warning';
      // }
      // return 'bg-success';
      return 'sgp-info';
    }
  }
};